import BaseAsset from "@/model/general-assets/BaseAsset";
import { MatchQuery, queryAllAssetsChained } from "@/services/DataService";
import { useDispatch } from "react-redux";
import PromiseLoader from "../PromiseLoader/PromiseLoader";
// import "./AssetQuery.scss";

interface AssetQueryProps {
  assetType: string;
  query: MatchQuery;
  expandKeys?: string[];
  sort?: { fieldName: string; sortKey: 1 | -1 }[];

  render: (
    data: BaseAsset[],
    reload: (silent?: boolean) => void
  ) => JSX.Element;
}
const AssetQuery = (props: AssetQueryProps) => {
  const dispatch = useDispatch();
  return (
    <PromiseLoader
      promise={async (params) => {
        const data = await queryAllAssetsChained(
          dispatch,
          props.assetType,
          props.query,
          props.sort,
          props.expandKeys
        );

        return data;
      }}
      render={(data, reload) => props.render(data, reload)}
    />
  );
};

export default AssetQuery;
